<template>
  <ButtonIcon
    :tabindex="tabindex"
    :href="href"
    :disabled="disabled"
    :loading="loading"
    :label="label"
    :colors="computedColors"
    :size="size"
    :icon="icon"
    :char="char"
    data-testid="button-icon-contextual"
    v-on="$listeners"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import ButtonIcon from '@/foundation/button-icon/ButtonIcon.vue';
import { contextualColors, contextualOverImage } from '@/styles/Button';
import { ButtonApplication, ButtonSizes } from '@/foundation/types';
import { ButtonColors } from '@/foundation/models/Button';

@Component({
  name: 'ButtonIconContextual',
  components: { ButtonIcon }
})
export default class ButtonIconContextual extends Vue {
  /**
   * O rótulo do botão.
   * A label não é exibida, mas é adicionada por questão de acessibilidade
   */
  @Prop({ type: String, required: true })
  readonly label!: string;

  /**
   * Permite atribuir um link ao botão
   */
  @Prop({ type: String, required: false })
  readonly href?: string;

  /**
   * Desativa o botão
   */
  @Prop({ type: Boolean, required: false })
  readonly disabled?: boolean;

  /**
   * Define qual a posição do elemento durante a navegação pelo teclado. Na maioria dos casos, não é necessário alterar o valor padrão.
   * @see {@link https://developer.mozilla.org/pt-BR/docs/Web/HTML/Global_attributes/tabindex}
   */
  @Prop({ type: Number, required: false })
  readonly tabindex?: number;

  /**
   * Coloca o botão no estado "carregando"
   */
  @Prop({ type: Boolean, required: false })
  readonly loading?: boolean;

  /**
   * Define o tamanho do botão
   * @values small, regular, large
   */
  @Prop({
    type: String,
    default: ButtonSizes.REGULAR
  })
  readonly size!: string;

  /**
   * O ícone a ser exibido
   * O `icon` tem precedência ao `char`
   */
  @Prop({
    type: String,
    required: false
  })
  readonly icon?: string;

  /**
   * O caractere a ser exibido
   */
  @Prop({
    type: String,
    required: false
  })
  readonly char?: string;

  /**
   * Define qual a superfície onde o botão está inserido
   * @values normal, overImage
   */
  @Prop({
    type: String,
    default: ButtonApplication.NORMAL
  })
  readonly appliedOn!: ButtonApplication;

  private get computedColors(): ButtonColors {
    switch (this.appliedOn) {
      case ButtonApplication.OVER_IMAGE:
        return contextualOverImage;
      case ButtonApplication.NORMAL:
      default:
        return contextualColors;
    }
  }
}
</script>
